import type { Rng } from '../rng';
import type { Action, PlayerView } from '../types';

/** Bot fácil: espalha reforços, ataca com risco, ignora boss na maior parte das vezes. */
export function chooseEasy(v: PlayerView, legal: Action[], rng: Rng): Action {
  const end = legal.find((a) => a.type === 'endPhase');
  if (v.pending) {
    if (v.pending.kind === 'conquest') {
      const moves = legal.filter((a) => a.type === 'moveIn');
      return moves[0]; // move o mínimo: deixa a conquista frágil
    }
    return legal[rng.int(legal.length)];
  }
  if (v.phase === 'setup') {
    const singles = legal.filter((a) => a.type === 'place' && a.count === 1);
    return singles.length ? singles[rng.int(singles.length)] : legal[0];
  }
  const loot = legal.filter((a) => a.type === 'playLoot');
  if (loot.length && rng.next() < 0.15) return loot[rng.int(loot.length)];

  const trades = legal.filter((a) => a.type === 'trade');
  if (trades.length && legal.every((a) => a.type === 'trade')) return trades[0];

  const places = legal.filter((a) => a.type === 'place' && a.count === 1);
  if (places.length) return places[rng.int(places.length)];

  if (v.phase === 'attack') {
    const boss = legal.filter((a) => a.type === 'attackBoss');
    if (boss.length && rng.next() < 0.15) return boss[0];
    if (rng.next() < 0.25) return end ?? legal[0];
    const attacks = legal.filter((a) => {
      if (a.type !== 'attack' || a.untilEnd) return false;
      return v.territories[a.from].troops >= v.territories[a.to].troops;
    });
    if (attacks.length) return attacks[rng.int(attacks.length)];
    return end ?? legal[0];
  }
  if (v.phase === 'fortify' && rng.next() < 0.3) {
    const moves = legal.filter((a) => a.type === 'fortify');
    if (moves.length) return moves[rng.int(moves.length)];
  }
  return end ?? legal[rng.int(legal.length)];
}
